const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3006/api';

// Auth-specific API calls (use fetch directly for auth to handle credentials properly)
export const verifyAuth = async () => {
  const response = await fetch(`${API_BASE_URL}/auth/verify`, {
    credentials: 'include'
  });

  if (!response.ok) { 
    throw new Error('Authentication verification failed');
  }

  return response.json();
};

export const loginUser = async (username, password) => {
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({ username, password })
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Login failed');
  }

  return data;
};

export const logoutUser = async () => {
  const response = await fetch(`${API_BASE_URL}/auth/logout`, {
    method: 'POST',
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error('Logout failed');
  }

  return response.json();
};
